import { useReducedMotion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { ChatMarkdown } from "@/core/components/chat-markdown";

export const AssistantReply = ({
  content,
  streaming,
  animate,
}: {
  content: string;
  streaming: boolean;
  animate: boolean;
}) => {
  const reduceMotion = useReducedMotion();
  const current = useRef(animate && !reduceMotion ? "" : content);
  const [visible, setVisible] = useState(current.current);
  useEffect(() => {
    if (!animate || reduceMotion) return;
    let offset = content.startsWith(current.current)
      ? current.current.length
      : 0;
    let timer: ReturnType<typeof setTimeout>;
    const advance = () => {
      offset = Math.min(
        content.length,
        offset + Math.max(6, Math.ceil((content.length - offset) / 14)),
      );
      // Keep an emoji's surrogate pair together at the reveal boundary.
      if (
        offset < content.length &&
        /[\uD800-\uDBFF]/.test(content[offset - 1] ?? "")
      )
        offset++;
      current.current = content.slice(0, offset);
      setVisible(current.current);
      if (offset < content.length) timer = setTimeout(advance, 32);
    };
    if (offset < content.length) timer = setTimeout(advance, 32);
    return () => clearTimeout(timer);
  }, [content, animate, reduceMotion]);
  const text =
    !animate || reduceMotion
      ? content
      : content.startsWith(visible)
        ? visible
        : "";
  const pending = streaming || text.length < content.length;
  return (
    <section aria-label="Assistant reply" aria-busy={pending}>
      <ChatMarkdown streaming={pending}>{text}</ChatMarkdown>
    </section>
  );
};
